import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import s from "../../com-components/delivery-details/deliveryDetails.vue.js";
import "../../com-components/delivery-details/deliveryDetails.vue2.js";
import { vCopyVueucStylesToShadowDom as a } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { themeOverrides as l } from "../../constants/themeConfig.js";
import { defineComponent as p, useTemplateRef as c, withDirectives as d, openBlock as u, createBlock as _, withCtx as h, createVNode as v } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as y } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
const O = /* @__PURE__ */ p({
  __name: "index.ce",
  setup(x, { expose: f }) {
    const o = y(), t = c("deliveryDetailsRef");
    function n(r, i) {
      var m;
      (m = t.value) == null || m.open(r, i);
    }
    return f({ open: n }), (r, i) => d((u(), _(e(w), {
      "style-mount-target": e(o),
      locale: e(R),
      "theme-overrides": e(l)
    }, {
      default: h(() => [
        v(s, {
          ref_key: "deliveryDetailsRef",
          ref: t
        }, null, 512)
      ]),
      _: 1
    }, 8, ["style-mount-target", "locale", "theme-overrides"])), [
      [e(a), e(o)]
    ]);
  }
});
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-details/index.ce.vue2.js
// module id = 1229
// module chunks = 41